import { useQuery, UseQueryResult } from 'react-query';
import type { HotlineMetaData, ResponseFormat } from '../algebra/global';

import { Http } from '../prelude/http';

export const useOnlineHotlineAvailable = (key: string): UseQueryResult<HotlineMetaData> => {
  return useQuery(
    ['entry-point', key],
    () => Http.AwsWafIntegrationRequest<ResponseFormat<HotlineMetaData>>('GET', `/hotlines/api/v1/ingress/endpoints.status?messaging_service_key=${key}`).then((res) => res.data),
    {
      enabled: key !== undefined,
    }
  );
};
